<template>
  <div id="app" ref="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    generateUUID() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    }
  }
};
</script>

<style>
:root {
  --admin-bg: #f4f7fb;
  --admin-card-bg: #ffffff;
  --admin-border: #e7ecf5;
  --admin-border-soft: #eef2f8;
  --admin-text: #223457;
  --admin-text-soft: #7f8eaa;
  --admin-primary: #4f7df7;
  --admin-primary-deep: #3d68df;
  --admin-shadow: 0 16px 40px rgba(31, 51, 91, 0.08);
  --admin-radius: 16px;
}

html,
body,
#app {
  min-height: 100%;
}

html,
body,
div,
span,
p,
a,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

body {
  background: var(--admin-bg);
  color: var(--admin-text);
  font-family: 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

a {
  color: inherit;
  text-decoration: none;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(145, 160, 190, 0.7);
}

::-webkit-scrollbar-track {
  background: transparent;
}

.el-table__body-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.el-card {
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius);
  box-shadow: var(--admin-shadow);
}

.el-card__header {
  border-bottom: 1px solid var(--admin-border-soft);
  color: var(--admin-text);
  font-weight: 700;
}

.el-dialog {
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(21, 40, 78, 0.16);
}

.el-dialog__header {
  padding: 20px 24px 10px;
}

.el-dialog__title {
  color: var(--admin-text);
  font-size: 18px;
  font-weight: 700;
}

.el-dialog__body {
  padding: 18px 24px 24px;
}

.el-form-item__label {
  color: #5a6c91;
  font-weight: 600;
}

.el-input__inner,
.el-textarea__inner,
.el-select .el-input__inner {
  border: 1px solid #dce3f0;
  border-radius: 12px;
  background: #fff;
  color: var(--admin-text);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.el-input__inner {
  height: 40px;
}

.el-input__inner:focus,
.el-textarea__inner:focus,
.el-select .el-input__inner:focus {
  border-color: rgba(79, 125, 247, 0.6);
  box-shadow: 0 0 0 3px rgba(79, 125, 247, 0.12);
}

.el-button {
  border-radius: 12px;
  font-weight: 600;
}

.el-button--primary {
  border-color: transparent;
  background: linear-gradient(135deg, var(--admin-primary), var(--admin-primary-deep));
  box-shadow: 0 12px 26px rgba(79, 125, 247, 0.22);
}

.el-button--primary:hover,
.el-button--primary:focus {
  border-color: transparent;
  background: linear-gradient(135deg, #5a85f8, #446ee2);
}

.el-button--default:hover,
.el-button--default:focus {
  color: var(--admin-primary);
  border-color: rgba(79, 125, 247, 0.3);
  background: rgba(79, 125, 247, 0.04);
}

.el-table {
  overflow: hidden;
  border: 1px solid var(--admin-border);
  border-radius: 16px;
}

.el-table::before {
  display: none;
}

.el-table th.el-table__cell {
  background: #f7f9fc;
  color: #5d6f92;
  font-weight: 700;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom-color: var(--admin-border-soft);
}

.el-table tr:hover > td.el-table__cell {
  background: #f9fbff !important;
}

.el-pagination {
  padding-top: 8px;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  min-width: 34px;
  height: 34px;
  border-radius: 10px;
  line-height: 34px;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: linear-gradient(135deg, var(--admin-primary), var(--admin-primary-deep));
}

.el-tabs--border-card {
  border: 1px solid var(--admin-border);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: none;
}

.el-tabs--border-card > .el-tabs__header {
  background: #f7f9fc;
  border-bottom: 1px solid var(--admin-border-soft);
}

.el-drawer {
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
}

.el-drawer__header {
  margin-bottom: 0;
  padding: 20px 24px 12px;
  color: var(--admin-text);
  font-size: 18px;
  font-weight: 700;
}

.el-message,
.el-notification {
  border-radius: 16px;
}

.el-menu--popup {
  padding: 8px;
  border: 1px solid #e2e9f5;
  border-radius: 16px;
  background: #ffffff !important;
  box-shadow: 0 20px 44px rgba(28, 46, 84, 0.16);
}

.el-menu--popup .el-menu-item,
.el-menu--popup .el-submenu__title {
  height: 42px;
  border-radius: 12px;
  background: transparent !important;
  color: #31466f !important;
  line-height: 42px;
  font-weight: 600;
}

.el-menu--popup .el-menu-item i,
.el-menu--popup .el-submenu__title i {
  color: inherit !important;
}

.el-menu--popup .el-menu-item:hover,
.el-menu--popup .el-submenu__title:hover {
  background: #eef4ff !important;
  color: #315fd4 !important;
}

.el-menu--popup .el-menu-item.is-active,
.el-menu--popup .el-submenu.is-active > .el-submenu__title {
  background: linear-gradient(135deg, var(--admin-primary), var(--admin-primary-deep)) !important;
  color: #ffffff !important;
  box-shadow: 0 10px 22px rgba(79, 125, 247, 0.2);
}

.el-tooltip__popper.is-dark {
  border-radius: 12px;
  background: #233553 !important;
  color: #ffffff !important;
  box-shadow: 0 14px 30px rgba(22, 37, 68, 0.22);
}
</style>
